// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","home--first":"Home_home--first__h4LWb","extendable-line":"Home_extendable-line__ofmjg","home--second":"Home_home--second__ccWE-","btn":"Home_btn__1s3qV"};